/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable multiline-ternary */
import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
  IconButton,
  Typography
} from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import ImageIcon from '@material-ui/icons/Image'
import React, { useState } from 'react'
import { Workspace } from '../../../providers/workspace'
import { CancelButton, SuccessButton } from '../../Buttons'
import { useProfileCardStyles } from './styles'

type Props = {
  editingWorkspace: Workspace
  onDeleteImage: () => void
  onSelectImage: (file: File) => void
  thumb: string
}

export const CardProfile = ({
  editingWorkspace,
  thumb,
  onDeleteImage,
  onSelectImage
}: Props): JSX.Element => {
  const [editMode, setEditMode] = useState<boolean>(false)
  const classes = useProfileCardStyles()
  const inputRef = React.useRef<any>()

  const handleSelectImage: React.ChangeEventHandler<HTMLInputElement> = e => {
    const files = e.target.files
    if (!files?.length) return

    onSelectImage(files?.[0])
    setEditMode(false)
    inputRef.current.value = ''
  }

  return (
    <div className={classes.root}>
      <h1 className={classes.title}>Foto de perfil / Assinatura</h1>
      <h2 className={classes.description}>Prévia do cartão pessoal</h2>
      <div className={classes.cardContainer}>
        {editMode ? (
          <Card elevation={0} style={{ background: '#4F4F4F', padding: 25 }}>
            <CardActions>
              <CancelButton
                onClick={() => {
                  setEditMode(false)
                  onDeleteImage()
                }}
                color="primary"
                startIcon={<DeleteIcon />}
              >
                Deletar Imagem
              </CancelButton>
              <SuccessButton
                onClick={() => inputRef.current?.click()}
                color="primary"
                startIcon={<ImageIcon />}
              >
                Selecionar Imagem
              </SuccessButton>
              <input
                hidden
                type="file"
                accept="image/*"
                onChange={handleSelectImage}
                ref={inputRef}
              />
            </CardActions>
          </Card>
        ) : (
          <Card className={classes.card} elevation={0}>
            <CardMedia
              className={classes.cover}
              image={thumb as string}
              title={editingWorkspace?.name}
            />
            <div className={classes.details}>
              <CardContent className={classes.content}>
                <Typography variant="subtitle1" color="primary">
                  {editingWorkspace?.company}
                </Typography>
                <Typography variant="subtitle1">
                  {editingWorkspace?.name}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  CRM: {editingWorkspace?.crm}
                </Typography>
              </CardContent>
            </div>
            <CardActions>
              <IconButton onClick={() => setEditMode(true)}>
                <EditIcon />
              </IconButton>
            </CardActions>
          </Card>
        )}
      </div>
    </div>
  )
}
